<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <card>
                    <template slot="header">
                        <h3 class="card-title">Podešavanja fiskalizacije</h3>
                    </template>

                    <el-tabs v-model="activeTab" type="border-card">
                        <!-- TAB 1: FISKAL -->
                        <el-tab-pane label="Fiskalizacija" name="fiscal">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <label>Fiskal URL</label>
                                        <input type="text" class="form-control" v-model="settings.fiscalUrl"
                                            placeholder="https://fiscal.oblak.online/pos/racun">
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>ENU kod</label>
                                                <input type="text" class="form-control" v-model="settings.enuCode"
                                                    placeholder="ENU kod uređaja">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>PDV stopa (%)</label>
                                                <input type="number" class="form-control" v-model.number="settings.vatRate"
                                                    placeholder="21">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Korisničko ime</label>
                                                <input type="text" class="form-control" v-model="settings.username"
                                                    placeholder="oblak">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Lozinka</label>
                                                <div class="input-with-eye">
                                                    <input :type="showPassword ? 'text' : 'password'" class="form-control"
                                                        v-model="settings.password" placeholder="••••••••">
                                                    <i class="tim-icons" :class="showPassword ? 'icon-zoom-split' : 'icon-bullet-list-67'"
                                                        @click="showPassword = !showPassword"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label>Naziv artikla</label>
                                        <input type="text" class="form-control" v-model="settings.itemName"
                                            placeholder="Parking">
                                        <small style="color: #888;">Šalje se kao naziv artikla na fiskalizaciji, sa nazivom zone (npr. "Parking - Zona 1").</small>
                                    </div>

                                    <div class="form-group">
                                        <label>Header računa (svaki red posebno)</label>
                                        <textarea class="form-control header-textarea" v-model="settings.receiptHeader"
                                            placeholder="Parking servis Nikšić&#10;Nikšić, Njegoševa 18&#10;Parking - Naplatni punkt 1&#10;Radoja Dakića bb&#10;PIB: 03061655"></textarea>
                                    </div>

                                    <base-button type="success" class="mt-3" @click="saveSettings()">
                                        <i class="tim-icons icon-check-2"></i> Sačuvaj
                                    </base-button>
                                </div>
                                <div class="col-md-4">
                                    <div class="info-panel">
                                        <h4><i class="tim-icons icon-bulb-63"></i> Pomoć</h4>
                                        <p style="color: #ccc;">Podaci za slanje računa na oblak fiskalizaciju kada se parking plati preko aplikacije.</p>
                                        <table class="placeholder-table">
                                            <tr><td><code>Fiskal URL</code></td><td>Adresa fiskal servisa</td></tr>
                                            <tr><td><code>ENU kod</code></td><td>Kod fiskalnog uređaja</td></tr>
                                            <tr><td><code>PDV stopa</code></td><td>Npr. 21</td></tr>
                                            <tr><td><code>Header</code></td><td>Zaglavlje računa, centrira se automatski</td></tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>

                        <!-- TAB 2: PLACANJE / WSPAY -->
                        <el-tab-pane label="Plaćanje (WSPay)" name="payment">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <label>Form API URL</label>
                                        <input type="text" class="form-control" v-model="settings.paytenFormApiUrl"
                                            placeholder="https://formtest.wspay.biz/authorization.aspx">
                                    </div>
                                    <div class="form-group">
                                        <label>Callback URL</label>
                                        <input type="text" class="form-control" v-model="settings.paytenCallbackUrl"
                                            placeholder="https://...">
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Shop ID</label>
                                                <input type="text" class="form-control" v-model="settings.wspayShopId"
                                                    placeholder="PSHNAPPME">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Secret Key</label>
                                                <div class="input-with-eye">
                                                    <input :type="showSecret ? 'text' : 'password'" class="form-control"
                                                        v-model="settings.wspaySecretKey" placeholder="••••••••">
                                                    <i class="tim-icons" :class="showSecret ? 'icon-zoom-split' : 'icon-bullet-list-67'"
                                                        @click="showSecret = !showSecret"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Valuta</label>
                                                <input type="text" class="form-control" v-model="settings.wspayCurrency"
                                                    placeholder="EUR">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>Jezik</label>
                                                <input type="text" class="form-control" v-model="settings.wspayLang"
                                                    placeholder="hr">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <el-checkbox v-model="settings.wspayTestMode" class="payment-checkbox">Test mod</el-checkbox>
                                    </div>

                                    <base-button type="success" class="mt-3" @click="saveSettings()">
                                        <i class="tim-icons icon-check-2"></i> Sačuvaj
                                    </base-button>
                                </div>
                                <div class="col-md-4">
                                    <div class="info-panel">
                                        <h4><i class="tim-icons icon-bulb-63"></i> Pomoć</h4>
                                        <p style="color: #ccc;">Parametri koji se šalju mobilnoj aplikaciji za WSPay plaćanje.</p>
                                        <table class="placeholder-table">
                                            <tr><td><code>Test mod</code></td><td>Uključi za testno okruženje</td></tr>
                                            <tr><td><code>Valuta</code></td><td>Npr. EUR</td></tr>
                                            <tr><td><code>Jezik</code></td><td>hr / en / sr</td></tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/util/axiosinstance';
import { Tabs, TabPane, Checkbox } from 'element-ui';

export default {
    components: {
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Checkbox.name]: Checkbox
    },
    data() {
        return {
            url: 'https://budva.scancar.org:8443/kuca',
            loading: false,
            activeTab: 'fiscal',
            showPassword: false,
            showSecret: false,
            settings: {
                id: null,
                fiscalUrl: '',
                enuCode: '',
                username: '',
                password: '',
                vatRate: 21,
                itemName: 'Parking',
                receiptHeader: '',
                paytenFormApiUrl: '',
                paytenCallbackUrl: '',
                wspayShopId: '',
                wspaySecretKey: '',
                wspayTestMode: true,
                wspayCurrency: 'EUR',
                wspayLang: 'hr'
            }
        };
    },
    methods: {
        getSettings() {
            this.loading = true;
            axios.get(this.url + '/fiscal/getFiscalSettings').then(result => {
                this.loading = false;
                if (result.data.result === 'ok' && result.data.settings) {
                    let s = result.data.settings;
                    this.settings.id = s.id || null;
                    this.settings.fiscalUrl = s.fiscalUrl || '';
                    this.settings.enuCode = s.enuCode || '';
                    this.settings.username = s.username || '';
                    this.settings.password = s.password || '';
                    this.settings.vatRate = (s.vatRate != null) ? s.vatRate : 21;
                    this.settings.itemName = s.itemName || 'Parking';
                    this.settings.receiptHeader = s.receiptHeader || '';
                    this.settings.paytenFormApiUrl = s.paytenFormApiUrl || '';
                    this.settings.paytenCallbackUrl = s.paytenCallbackUrl || '';
                    this.settings.wspayShopId = s.wspayShopId || '';
                    this.settings.wspaySecretKey = s.wspaySecretKey || '';
                    this.settings.wspayTestMode = s.wspayTestMode || false;
                    this.settings.wspayCurrency = s.wspayCurrency || 'EUR';
                    this.settings.wspayLang = s.wspayLang || 'hr';
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom učitavanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        saveSettings() {
            this.loading = true;
            axios.post(this.url + '/fiscal/saveFiscalSettings', this.settings).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Podešavanja uspešno sačuvana',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.getSettings();
                } else {
                    this.$notify({
                        message: result.data.reason || 'Greška prilikom čuvanja',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            }).catch(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        this.getSettings();
    }
};
</script>

<style scoped>
.header-textarea {
    width: 100%;
    min-height: 140px !important;
    height: 140px !important;
    background-color: #1e1e2d !important;
    border: 1px solid #2b3553 !important;
    color: #fff !important;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    padding: 10px;
    border-radius: 5px;
    resize: vertical !important;
}

.header-textarea:focus {
    border-color: #e14eca !important;
    outline: none;
}

.input-with-eye {
    position: relative;
}

.input-with-eye .form-control {
    padding-right: 38px;
}

.input-with-eye i {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #e14eca;
    cursor: pointer;
    font-size: 16px;
}

.info-panel {
    background-color: rgba(30, 136, 229, 0.1);
    border: 1px solid rgba(30, 136, 229, 0.3);
    border-radius: 5px;
    padding: 20px;
    height: 100%;
}

.info-panel h4 {
    color: #1e88e5;
    margin-bottom: 15px;
    font-size: 16px;
}

.info-panel h4 i {
    margin-right: 8px;
}

.placeholder-table {
    width: 100%;
    font-size: 13px;
    color: #fff;
}

.placeholder-table td {
    padding: 5px 0;
    vertical-align: top;
    color: #fff;
}

.placeholder-table td:first-child {
    width: 120px;
}

.placeholder-table code {
    background-color: rgba(0, 0, 0, 0.3);
    padding: 2px 6px;
    border-radius: 3px;
    color: #e14eca;
    font-size: 12px;
}

.payment-checkbox {
    color: #fff !important;
    margin-top: 10px;
}

/* Loader */
.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

.loader {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>

<!-- Element UI overrides - must be unscoped -->
<style>
.el-tabs--border-card {
    background-color: #27293d !important;
    border-color: #2b3553 !important;
    box-shadow: none !important;
}

.el-tabs--border-card > .el-tabs__header {
    background-color: #1e1e2d !important;
    border-bottom-color: #2b3553 !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: #9a9a9a !important;
    border-color: #2b3553 !important;
    background-color: transparent !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #fff !important;
    background-color: #27293d !important;
    border-color: #2b3553 !important;
    border-bottom-color: #27293d !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
    color: #e14eca !important;
}

.el-tabs__content {
    padding: 20px !important;
    background-color: #27293d !important;
}

/* Checkbox dark theme */
.payment-checkbox .el-checkbox__label {
    color: #fff !important;
}

.payment-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #e14eca !important;
    border-color: #e14eca !important;
}
</style>